let euWebUrl = 'https://localhost/';

if (process.env.REACT_APP_EU_WEB_URL) {
  euWebUrl = process.env.REACT_APP_EU_WEB_URL;
}

export default { euWebUrl };
